import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

export const SignaturePad = ({ onChange, testid = "signature-pad" }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#111827";
  }, []);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return { x: p.clientX - r.left, y: p.clientY - r.top };
  };

  const start = (e) => {
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
    e.preventDefault();
  };

  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    if (!hasInk) setHasInk(true);
    e.preventDefault();
  };

  const end = () => {
    if (drawing.current && onChange) {
      onChange(canvasRef.current.toDataURL("image/png"));
    }
    drawing.current = false;
  };

  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setHasInk(false);
    onChange && onChange(null);
  };

  return (
    <div data-testid={testid} className="w-full">
      <div className="relative rounded-xl border border-[#E5DED5] bg-white overflow-hidden">
        <canvas
          data-testid={`${testid}-canvas`}
          ref={canvasRef}
          className="w-full h-36 touch-none cursor-crosshair"
          onMouseDown={start}
          onMouseMove={move}
          onMouseUp={end}
          onMouseLeave={end}
          onTouchStart={start}
          onTouchMove={move}
          onTouchEnd={end}
        />
        {!hasInk && (
          <span className="absolute inset-0 flex items-center justify-center pointer-events-none text-[#9a938a] font-ui text-sm tracking-wide">
            Sign here with your finger or mouse
          </span>
        )}
      </div>
      <div className="mt-2 flex justify-end">
        <button type="button" data-testid={`${testid}-clear`} onClick={clear} className="inline-flex items-center gap-1.5 text-xs font-ui text-muted-foreground hover:text-foreground transition-colors">
          <Eraser className="h-3.5 w-3.5" /> Clear signature
        </button>
      </div>
    </div>
  );
};
